


























	import Vue from 'vue';
    import _termine from '../../services/endpoints/termine';
    import HomepageTerminComp from "./HomepageTerminComp.vue";
	import { homepageTermin } from '../../../../models/Types';

    export default Vue.extend({
        name: "HomepageTermineComp",
        components: {HomepageTerminComp},
        data: () => ({
            termine: [] as homepageTermin[],
        }),
        computed: {
            listNotEmpty: function (): boolean {
                if (this.termine) {
                    return this.termine.length !== 0;
                } else {
                    return false;
                }
            }
        },
        created: async function (): Promise<void> {
            this.termine = await _termine.getHomepageTermine();
        }
    })
